export enum RoleEnum {
    BLOGGER = "BLOGGER",
    USER = "USER",
    ADMIN = "ADMIN"
}